import React from 'react';
import PropTypes from 'prop-types';

const MenuItem = ({ 'data-cy': dataCy, disabled, onClick, children }) => {

    const disableClass = disabled ? 'bf-menu-item-disabled' : '';

    return (
        <li data-cy={dataCy} onClick={disabled ? () => { } : onClick}
             className={`bf-menu-item items-center whitespace-normal ${disableClass}`}>
            {!Array.isArray(children) &&
                <div key={children}>{children}</div>
            }
            {Array.isArray(children) && children.map((child, index) => {
                return <div key={index}>{child}</div>
            })}
        </li>

    )
}

MenuItem.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

export default MenuItem;